import React from "react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { PresignedImageWithPlaceholder } from "@/components/common/PresignedImageWithPlaceholder";
import { StaffWithRelations } from "@/services/staffService";

interface NameCellProps {
  user: StaffWithRelations;
  position?: string;
  isOnSite?: boolean;
}

export const NameCell: React.FC<NameCellProps> = ({
  user,
  position,
  isOnSite,
}) => {
  return (
    <div className="flex flex-col items-center justify-center gap-3">
      <div className="relative shrink-0">
        <PresignedImageWithPlaceholder
          className="size-10 rounded-full object-cover"
          photo={user.photoId}
          alt={`${user.firstName} ${user.lastName}`}
          placeholder={
            <Avatar>
              <AvatarFallback>
                {user.firstName?.[0]}
                {user.lastName?.[0]}
              </AvatarFallback>
            </Avatar>
          }
        />
        {isOnSite && (
          <span className="border-background absolute right-0 bottom-0 size-3 rounded-full border-2 bg-green-500" />
        )}
      </div>
      <div className="flex flex-col items-center justify-center">
        <span className="font-medium">
          {user.firstName} {user.lastName}
        </span>
        <span className="text-muted-foreground text-xs">{position || ""}</span>
      </div>
    </div>
  );
};
